import { Icon } from "@/components/icons/Icon";
import { Pill } from "@/components/pill/Pill";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { QuestionFormType } from "@/types/types";
import type { FC } from "react";
import { Link } from "react-router-dom";

interface ChecklistBodyProps {
  tableData: QuestionFormType[];
}

const ChecklistBody: FC<ChecklistBodyProps> = ({ tableData }) => {
  const translate = useTranslate();
  return tableData.length > 0 ? (
    tableData.map((questionForm, index: number) => {
      return (
        <tr
          data-testid={`checklist-body-row-${index}`}
          key={`checklist-row-${index}`}
          className={`${index % 2 === 0 ? "table-odd-row" : "table-even-row"}${
            index === tableData.length - 1 ? " last-row" : ""
          } h-16 border-b border-b-ib-gray-lightest text-[14px] leading-[16px] text-ib-gray-darkest `}
        >
          <td className="p-3 text-center">{questionForm.type}</td>
          <td className="p-3 text-center">
            {new Date(questionForm.createdAt).toLocaleString()}
          </td>
          <td className="p-3 text-center">{questionForm.questionCount}</td>
          <td className="p-3 text-center">
            {questionForm.lastVersion ? (
              <Pill label={translate("on")} className="bg-[#ADE1C7]" />
            ) : (
              <Pill label={translate("off")} className="bg-ib-gray-borders" />
            )}
          </td>
          <td className="p-3 flex justify-end">
            <Link to={questionForm.id.toString()}>
              <div className="bg-[#F5F5F5] rounded-full flex items-center justify-center">
                <Icon name="chevronRight" />
              </div>
            </Link>
          </td>
        </tr>
      );
    })
  ) : (
    <></>
  );
};

export default ChecklistBody;
